import assets from "../../assets";
import useHandler from "./handler";

export const Footer = ({ preferences, setPreferences }) => {
  const { userProfileUpdate, initialPreferences } = useHandler();
  const handleSave = () => {
    // const selectedPreferences = preferences
    //   .filter((item) => item.enabled)
    //   .map((item) => item.id);

    // userProfileUpdate({
    //   preferences: selectedPreferences,
    // });

    // const selectedPreferences = preferences.filter((item) => item.enabled);

    // selectedPreferences.forEach((item) => {
    //   userProfileUpdate({
    //     exam_type: item.title, // or item.id based on API
    //   });
    // });

    // // only one

    // const selected = preferences.find((item) => item.enabled);

    // if (selected) {
    //   userProfileUpdate(selected.title);
    // }

    const selected = preferences.find((item) => item.enabled);

    if (!selected) return;

    userProfileUpdate({
      exam: selected.title,
      class_grade: selected.classGrade,
      medium: selected.medium,
    });
  };

  const handleReset = () => {
    setPreferences(initialPreferences);
  };

  return (
    <footer className="profile-footer">
      <section className="learning_card">
        <img src={assets.ic_heart} />
        Powered by Rovian Learning AI
      </section>
      <section className="footer_btn_wrapper">
        {/* <button className="refresh_btn_ref" onClick={handleReset}>
          <img src={assets.ic_refresh_red} className="refresh_icon" />
          Reset Preferences
        </button> */}
        <button className="save_btn" onClick={handleSave}>
          Save Changes
        </button>
      </section>
    </footer>
  );
};
